/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.business.internal

import features.business.models.Business
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.business.internal.BusinessUseCase.Params

internal class BusinessUseCase : AsyncUseCase<Business, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val businessService: BusinessService = BusinessServiceImpl()

    override suspend fun run(params: Params): Result<Business> {
        return businessService.getBusiness(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
